import { NgModule }                 from '@angular/core';
import { Http, RequestOptions }     from '@angular/http';
import { AuthGuardService }         from './auth-guard/auth-guard.service';
import { AuthGuardAdminService }    from './auth-guard-admin/auth-guard-admin.service';
import { ConfigService }            from './configuracion/config.service';
import { BproyectoService }         from './bproyecto/bproyecto.service';
import { EmailService }             from './email/email.service';
import { EmailEncuestaService }     from './email-encuesta/email-encuesta.service';
import { EncuestaService }          from './encuesta/encuesta.service';
import { EtiquetaService }          from './etiqueta/etiqueta.service';
import { EtiquetaPreguntaService }  from './etiqueta-pregunta/etiqueta-pregunta.service';
import { HechoService }             from './hecho/hecho.service';
import { OpcionRespuestaService }   from './opcion-respuesta/opcion-respuesta.service';
import { OrganizacionService }      from './organizacion/organizacion.service';
import { PermisosService }          from './permisos/permisos.service';
import { PreguntaService }          from './pregunta/pregunta.service';
import { ProyectoService }          from './proyecto/proyecto.service';
import { RequestBaseService }       from './request-base/request-base.service';
import { RespuestaService }         from './respuesta/respuesta.service';
import { TipoRespuestaService }     from './tipo-respuesta/tipo-respuesta.service';
import { UsuarioService }           from './usuario/usuario.service';


@NgModule({
  providers: [
    AuthGuardService,
    AuthGuardAdminService,
    ConfigService,
    BproyectoService,
    EmailService,
    EmailEncuestaService,
    EncuestaService,
    EtiquetaService,
    EtiquetaPreguntaService,
    HechoService,
    OpcionRespuestaService,
    OrganizacionService,
    PermisosService,
    PreguntaService,
    ProyectoService,
    RequestBaseService,
    RespuestaService,
    TipoRespuestaService,
    UsuarioService
  ]
})
export class ServicesModule {
  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/services/services.module.ts